import React from "react";

import RbSnackbarContext from "components/RbSnackbarProvider/RbSnackbarContext";

function useSnackbar() {
  const context = React.useContext(RbSnackbarContext);

  if (!context) {
    throw new Error(`useSnackbar must be used within a RbSnackbarProvider`);
  }

  return context;
}

export default useSnackbar;
